import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';

export const generateMeasurement = async (formData: FormData) => {
    // @ts-ignore
    const url = routable.getRoute('generateProjectMeasurement');
    try {
        const res = await $api.post(url, formData);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error.response.data);
        return error.response.data;
    }
};
